import { useParams } from 'react-router-dom';
import DriverSettlementList from './list';
import DriverSettlementView from './view';

export default function DriverSettlement() {
  const { id } = useParams();
  switch (id) {
    case undefined:
      return <DriverSettlementList />;
    default:
      return <DriverSettlementView />;
  }
}

